import { connect } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../redux/deviations/selectors';
import { getIsAnyPanelVisible } from '../DeviationPage/redux/selectors';
import { getIsBackgroundsPopupOpen } from '../DeviationBackground/redux/selectors';
const mapStateToProps = (state, ownProps)=>({
        isAnyDialogOpen: getIsAnyPanelVisible(state) || getIsBackgroundsPopupOpen(state),
        isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation)
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
